module.exports = __webpack_public_path__ + "static/img/offline-api.7eb15656.png";